import React from 'react';
import { Box, Typography } from '@mui/material';
import { IconWrapper, InfoCard, SparkAccordion } from 'sharedComponents/UI';
import SubAccordionIconWrapper from './SubAccordionIconWrapper';
import TaggedParameter from './TaggedParameter';
import type {
  SparkReferenceSparkStep,
  SparkReferenceValue,
} from 'types/SparkStepReference';
import { useSparkStepTypes } from 'hooks/EntityTypes/useSparkStepTypes';
import { SparkImageLoader } from 'sharedComponents/UI';

type SparkStepAccordionProps = {
  sparkSteps: SparkReferenceSparkStep[] | undefined;
  onTagClick: (value: SparkReferenceValue) => void;
};
function SparkStepAccordion({
  sparkSteps,
  onTagClick,
}: SparkStepAccordionProps) {
  const countSparkSteps = sparkSteps?.length || 0;
  const { idMap: stepTypeIdMap } = useSparkStepTypes();

  return (
    <>
      {countSparkSteps > 0 ? (
        sparkSteps?.map((step, index) => (
          <SparkAccordion
            title={`${index + 1}. ${step.name}`}
            icon={
              <SubAccordionIconWrapper>
                <IconWrapper size='small' sx={{ borderRadius: '50%' }}>
                  <SparkImageLoader
                    src={
                      stepTypeIdMap?.[step.sparkStepTypeID].attributes.iconURL
                    }
                    alt={stepTypeIdMap?.[step.sparkStepTypeID].attributes.name}
                    width='100%'
                    height='100%'
                  />
                </IconWrapper>
              </SubAccordionIconWrapper>
            }
            accordionTitleProps={{ marginLeft: -1.5 }}
            key={step.id}
            summaryStyles={{
              cursor: 'pointer',
              padding: 0,
            }}
            detailsStyle={{ paddingBottom: 2 }}
            sx={{
              '&:hover': {
                borderColor: (theme) => theme.palette.primary.main,
              },
            }}
          >
            <Box display='flex' flexDirection='column' gap={2}>
              {step.meta.referenceValues.length === 0 && (
                <Box marginX={1}>
                  <InfoCard type='warning' info='Complete this step' />
                </Box>
              )}
              {step.meta.referenceValues.map((metaReference, index) => (
                <TaggedParameter
                  label={metaReference.key}
                  output={metaReference.value}
                  key={index}
                  iconURL={metaReference.iconURL}
                  onClick={() => {
                    onTagClick(metaReference);
                  }}
                />
              ))}
            </Box>
          </SparkAccordion>
        ))
      ) : (
        <Typography ml={1.5}>No Step</Typography>
      )}
    </>
  );
}

export default SparkStepAccordion;
